import React, { useState } from 'react';

import { makeStyles } from '@mui/styles';

import { Card, Box, Grid, Typography, Accordion, Stack, Skeleton } from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';

// utils
import Pagination from '../../Pagination';
import { fNumber } from '../../../utils/formatNumber';
import { fDateTime } from '../../../utils/formatTime';
import { getLlockOpenedByChannelIcon, getNotificationEventStatus } from '../../../utils/Utilities';
import NoDataAvailable from './NoDataAvailable';

const useStyles = makeStyles((theme) => ({
  customDashCard: {
    background: '#FFFFFF',
    minHeight: '190px',
    boxShadow: '10px 10px 19px 1px #EAEAFF',
    borderRadius: '20px'
  },
  labelTypography: {
    textAlign: 'left',
    fontSize: 14,
    color: 'black',
    [theme.breakpoints.down('sm')]: {
      fontSize: 12
    }
  },
  valueTypography: {
    textAlign: 'left',
    fontSize: 14,
    color: 'black',
    [theme.breakpoints.down('sm')]: {
      fontSize: 12
    }
  },
  notFoundContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));

export default function LockHistory({
  tripHistoryData,
  loader,
  setPageNumber,
  pageNumber,
  setDataPerPage,
  dataPerPage
}) {
  const classes = useStyles();

  const handlePage = (event, newPage) => {
    setPageNumber(newPage);
  };

  const handleDataPerPage = (event) => {
    setDataPerPage(parseInt(event.target.value, 10));
    setPageNumber(0);
  };

  return (
    <Box>
      {tripHistoryData?.data?.eventData?.length === 0 ? (
        <NoDataAvailable />
      ) : (
        <>
          <Grid container spacing={1}>
            {tripHistoryData?.data?.eventData?.map((loc, index) =>
              loader ? (
                <Skeleton sx={{ width: '100%', marginBottom: '10px' }} variant="rectangular" />
              ) : (
                <React.Fragment key={index}>
                  <Grid item xs={4} md={6}>
                    <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                      <Typography className={classes.valueTypography}>
                        {getNotificationEventStatus(loc?.event_type)}
                      </Typography>
                      {loc?.event_type === 'LOCK_OPENED' &&
                        getLlockOpenedByChannelIcon(loc?.channel)}
                    </div>
                  </Grid>

                  <Grid item xs={4} md={2}>
                    {loc?.event_type === 'BATTERY_LOW' ? (
                      <Typography
                        sx={{ color: 'red !important' }}
                        className={classes.valueTypography}
                      >
                        {fNumber(loc?.battery_remaining)} %
                      </Typography>
                    ) : null}
                  </Grid>

                  <Grid item xs={4} md={4} sx={{ padding: '0' }}>
                    <Typography
                      sx={{ fontSize: '12px !important', width: 'max-content' }}
                      className={classes.valueTypography}
                    >
                      {fDateTime(loc?.updatedAt)}
                    </Typography>
                  </Grid>
                </React.Fragment>
              )
            )}
          </Grid>
          {tripHistoryData?.pagination?.totalCount > 0 && (
            <Pagination
              pageNumber={pageNumber}
              limit={dataPerPage || 10}
              handleChangePage={handlePage}
              handleChangeRowsPerPage={handleDataPerPage}
              pageCount={tripHistoryData?.pagination?.totalCount || 0}
            />
          )}
        </>
      )}
    </Box>
  );
}
